export default "__VITE_ASSET__FqBXM2hf__"